var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { StyledInput, StyledLabel } from './styles';
var SelectedOption = /** @class */function (_super) {
  __extends(SelectedOption, _super);
  function SelectedOption(props) {
    var _this = _super.call(this, props) || this;
    _this.inputRef = React.createRef();
    return _this;
  }
  SelectedOption.prototype.componentDidUpdate = function (prevProps) {
    prevProps.isFiltering !== this.props.isFiltering ? this.props.isFiltering ? this.inputRef.current.focus() : this.inputRef.current.blur() : null;
  };
  SelectedOption.prototype.render = function () {
    var _a = this.props,
      inputTabIndex = _a.inputTabIndex,
      isFiltering = _a.isFiltering,
      selectedOption = _a.selectedOption,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      placeholder = _a.placeholder,
      readOnly = _a.readOnly,
      props = __rest(_a, ["inputTabIndex", "isFiltering", "selectedOption", "onFocus", "onBlur", "placeholder", "readOnly"]);
    return _jsxs(_Fragment, {
      children: [_jsx(StyledInput, __assign({
        readOnly: readOnly,
        ref: this.inputRef,
        isFiltering: isFiltering,
        onFocus: function (e) {
          e.stopPropagation();
          onFocus && onFocus(e);
        },
        onBlur: function (e) {
          e.stopPropagation();
          onBlur && onBlur(e);
        },
        tabIndex: inputTabIndex,
        placeholder: placeholder
      }, props)), !isFiltering ? React.isValidElement(selectedOption.label) ? React.cloneElement(selectedOption.label, {
        onClick: this.props.onClick
      }) : _jsx(StyledLabel, {
        onClick: this.props.onClick,
        title: selectedOption.label || placeholder,
        children: selectedOption.label || placeholder
      }) : null]
    });
  };
  SelectedOption.defaultProps = {
    onClick: function (ev) {
      //do nothing
    }
  };
  return SelectedOption;
}(React.PureComponent);
export { SelectedOption };